const namespace = 'patientAccount';

export const FETCH_PATIENT_ACCOUNT_PROFILE = `${namespace}/FETCH_PATIENT_ACCOUNT_PROFILE`;
export const SUBMIT_PATIENT_ACCOUNT_VOUCHER_TOPUP = `${namespace}/SUBMIT_PATIENT_ACCOUNT_VOUCHER_TOPUP`;
export const SET_VOUCHER_CODE_STATUS = `${namespace}/SET_VOUCHER_CODE_STATUS`;
export const RESET_VOUCHER_CODE_STATUS = `${namespace}/RESET_VOUCHER_CODE_STATUS`;
export const SUBMIT_PATIENT_ACCOUNT_PAGOPAR_TOPUP = `${namespace}/SUBMIT_PATIENT_ACCOUNT_PAGOPAR_TOPUP`;
export const CONFIRM_EMAIL = `${namespace}/CONFIRM_EMAIL`;
